import React, { useRef } from 'react';
import StableMuiDialog from '../../../common/StableMuiDialog.js';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useDragAndDrop } from './useDragAndDrop';

// Shared "click or drag a file to upload" dialog used by every photo-cell-shaped component.
const PhotoUploadDialog = ({ open, onClose, onUpload, uploading, dialogProps }) => {
  const fileInputRef = useRef(null);
  const { dragActive, dragHandlers } = useDragAndDrop(onUpload);

  const handleFileInput = (e) => {
    const file = e.target.files?.[0];
    if (file) onUpload(file);
    e.target.value = '';
  };

  return (
    <StableMuiDialog open={open} onClose={onClose} maxWidth="sm" fullWidth {...dialogProps}>
      <DialogTitle>Upload Photo</DialogTitle>
      <DialogContent>
        <div
          {...dragHandlers}
          style={{
            border: `2px dashed ${dragActive ? '#1976d2' : '#ccc'}`,
            borderRadius: '8px',
            padding: '20px',
            textAlign: 'center',
            backgroundColor: dragActive ? 'rgba(25, 118, 210, 0.04)' : 'transparent',
            transition: 'all 0.2s ease',
            cursor: uploading ? 'default' : 'pointer',
            opacity: uploading ? 0.7 : 1,
          }}
          onClick={() => !uploading && fileInputRef.current?.click()}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileInput}
          />
          {uploading ? (
            <div className="flex flex-col items-center gap-2">
              <CircularProgress size={40} />
              <span>Uploading...</span>
            </div>
          ) : (
            <>
              <CloudUploadIcon sx={{ fontSize: 48, color: dragActive ? '#1976d2' : '#666', mb: 2 }} />
              <div style={{ marginBottom: 8 }}>
                Click to select a file, or drag and drop an image here
              </div>
              <div style={{ fontSize: '0.875rem', color: '#666' }}>
                Supported formats: JPG, PNG, GIF (max 5MB)
              </div>
            </>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={uploading}>Cancel</Button>
      </DialogActions>
    </StableMuiDialog>
  );
};

export default PhotoUploadDialog;
